import { WEB_SHOP } from "src/utils/algolia/analyticsTags";

const DEFAULT_RULE_CONTEXTS = [WEB_SHOP];
const DEFAULT_ANALYTICS_TAGS = [WEB_SHOP];
const DEFAULT_HITS_PER_PAGE = 72;

export { DEFAULT_HITS_PER_PAGE, DEFAULT_ANALYTICS_TAGS, DEFAULT_RULE_CONTEXTS };
